var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var _createDotElement;
class CoralScrollCore {
  constructor(e) {
    __privateAdd(this, _createDotElement, (e) => `<button type="button" class="dot" data-index="${e}" aria-label="Select slide ${e}" name="Select slide ${e}"></button>`);
    __publicField(this, "sendEventScrolledToNewSlide", (e) => {
      e = new CustomEvent("scrolled-to-slide", { detail: { activeSlide: e, sendFromSliderElement: this.coralScrollElement } });
      document.dispatchEvent(e);
    });
    __publicField(this, "sendEventRequestToScrollToNewSlide", (e, t) => {
      e = new CustomEvent(
        "request-to-slide",
        { detail: { activeSlide: e, targetSliderClass: t, sendFromSliderElement: this.coralScrollElement } }
      );
      document.dispatchEvent(e);
    });
    __publicField(this, "debounce", (t, i = 50) => {
      let s;
      return (...e) => {
        clearTimeout(s), s = setTimeout(() => {
          t.apply(this, e);
        }, i);
      };
    });
    __publicField(this, "createSliderConfig", () => {
      var e = this.sliderElement.querySelectorAll(".slide:not(.js-hidden)") ? this.sliderElement.querySelectorAll(".slide:not(.js-hidden)")[0] : null;
      return {
        devMode: !!this.coralScrollElement.dataset.devMode && "true" === this.coralScrollElement.dataset.devMode,
        grabVelocity: this.coralScrollElement.dataset.grabVelocity || 100,
        autoScrollDuration: this.coralScrollElement.dataset.autoScroll || false,
        enableThumbs: this.coralScrollElement.dataset.thumbs || false,
        isThumbsSlider: !!this.coralScrollElement.dataset.isThumbsSlider,
        infinite: "true" === this.coralScrollElement.dataset.infiniteScroll,
        snapAlignStyle: e ? getComputedStyle(e)["scroll-snap-align"] : null,
        startPositionId: this.coralScrollElement.dataset.startPositionId
      };
    });
    __publicField(this, "getCurrentSliderStates", () => {
      if (!this.sliderElement) return null;
      var t = this.sliderElement.querySelectorAll(".slide:not(.js-hidden)"), t = t ? [...t] : null, i = getComputedStyle(this.sliderElement).paddingLeft.replace("px", ""), s = getComputedStyle(this.sliderElement).gap;
      const l = (s == null ? void 0 : s.split(" ")) ? s == null ? void 0 : s.split(" ")[0].replace("px", "") : s == null ? void 0 : s.replace("px", "");
      var r = this.sliderElement.getBoundingClientRect().width;
      const o = t.length, n = Number(
        this.sliderElement.getBoundingClientRect().left
      ) + Number(i);
      s = t.map((e) => {
        var t2 = e.getBoundingClientRect().x, i2 = e.getBoundingClientRect().width;
        this.sliderElement.getBoundingClientRect().width, getComputedStyle(this.sliderElement).paddingLeft.replace("px", ""), getComputedStyle(this.sliderElement).paddingRight.replace("px", "");
        switch (this.sliderConfig.snapAlignStyle) {
          case "start":
            return Number(t2) - Number(n);
          case "center":
            return Number(t2) - Number(n) + Number(i2 / 2);
          default:
            return t2;
        }
      }), i = t.map((e) => {
        var t2 = e.getBoundingClientRect().x, e = e.getBoundingClientRect().width;
        return Number(t2) + Number(e);
      }), t = t.map((e, t2) => {
        e = e.getBoundingClientRect().width;
        return t2 === o ? Number(e) : Number(e) + Number(l.match(/^[0-9]+$/) ? l : 0);
      });
      if (0 < s.length) {
        const h = s == null ? void 0 : s.reduce((e2, t2) => Math.abs(+t2) < Math.abs(+e2) ? t2 : e2);
        var d = s == null ? void 0 : s.findIndex((e2) => e2 === h), a = getComputedStyle(this.sliderElement).paddingRight.replace("px", ""), c = Math.ceil(i[o - 1]), i = d === Number(o) - 2;
        let e = null;
        switch (this.sliderConfig.snapAlignStyle) {
          case "start":
            e = Number(
              c
            ) + Number(a) <= Number(r) + 10 && Number(c) + Number(a) >= Number(r) - 10;
            break;
          case "center":
            e = c - a == r / 2;
            break;
          default:
            e = c === r;
        }
        t = { allSlideWidths: t, currentSlidePositions: s, activeSlide: d, isSlideTheSecondLastSlide: i, isSlideTheLastSlide: e, sliderElement: this.coralScrollElement };
        return this.sliderConfig.devMode && console.log(t), t;
      }
      return 0;
    });
    __publicField(this, "setActiveIndicator", (s) => {
      var e = this.coralScrollElement.querySelector(".coral-scroll__indicator");
      if (e) {
        e = e.querySelectorAll(".dot");
        const l = [...this.sliderElement.querySelectorAll(
          ".slide:not(.js-hidden)"
        )], r = l[s], o = r == null ? void 0 : r.classList.contains("js-clone");
        e.forEach((e2) => {
          if (e2.classList.remove("js-active"), o) {
            const i = r.dataset.cloneId;
            var t = l.findIndex((e3) => e3.dataset.slideId == i);
            Number(e2.dataset.index) === Number(t) && e2.classList.add("js-active");
          } else Number(e2.dataset.index) === Number(s) && e2.classList.add("js-active");
        });
      }
    });
    __publicField(this, "setActiveThumb", (n) => {
      var _a;
      var e = this.sliderConfig.enableThumbs;
      (_a = document.querySelectorAll("." + e)) == null ? void 0 : _a.forEach((e2) => {
        if (false === this.sliderConfig.isThumbsSlider && e2) {
          e2 = e2.querySelectorAll(
            ".slide"
          );
          const s = [...this.sliderElement.querySelectorAll(".slide:not(.js-hidden)")], l = s[n], r = l == null ? void 0 : l.dataset.imageId, o = l == null ? void 0 : l.classList.contains("js-clone");
          e2.forEach((e3) => {
            if (e3.classList.remove("js-active"), o) {
              const i = l.dataset.cloneId;
              var t = s.findIndex((e4) => e4.dataset.slideId == i);
              Number(e3.dataset.index) === Number(t) && (e3.classList.add("js-active"), this.sendEventRequestToScrollToNewSlide(n, this.sliderConfig.enableThumbs));
            } else e3.dataset.imageId === r && (e3.classList.add("js-active"), this.sendEventRequestToScrollToNewSlide(n, this.sliderConfig.enableThumbs));
          });
        }
      });
    });
    __publicField(this, "setActiveSlideClass", (e) => {
      var _a;
      var t = this.sliderElement.querySelectorAll(".slide:not(.js-hidden)"), t = t ? [...t] : null;
      null !== e && (t.map((e2) => {
        e2 == null ? void 0 : e2.classList.remove("js-active");
      }), 0 < t.length) && ((_a = t[Number(e)]) == null ? void 0 : _a.classList.add("js-active"));
    });
    __publicField(this, "setListenerArrows", () => {
      var e = this.coralScrollElement.querySelector(".coral-scroll__arrows");
      if (!e) return null;
      var t = e == null ? void 0 : e.querySelector(".previous"), e = e == null ? void 0 : e.querySelector(".next");
      t == null ? void 0 : t.addEventListener(
        "click",
        () => this.handlePreviousSlide()
      ), e.addEventListener("click", () => this.handleNextSlide());
    });
    __publicField(this, "setStylingArrows", () => {
      var e = this.coralScrollElement.querySelector(".coral-scroll__arrows");
      if (!e) return null;
      var t = e == null ? void 0 : e.querySelector(".previous"), e = e == null ? void 0 : e.querySelector(".next"), i = this.getCurrentSliderStates();
      t && (0 == (i == null ? void 0 : i.activeSlide) ? t.classList.add("js-disabled") : t.classList.remove("js-disabled")), e && (true === (i == null ? void 0 : i.isSlideTheLastSlide) ? e.classList.add("js-disabled") : e.classList.remove("js-disabled"));
    });
    __publicField(this, "setScrollPositionWithoutScroll", (i) => {
      var _a, _b;
      var e = (_a = this.getCurrentSliderStates()) == null ? void 0 : _a.allSlideWidths;
      0 <= i && (e = (_b = e == null ? void 0 : e.map((e2, t) => {
        if (t <= i - 1) return e2;
      }).filter((e2) => e2)) == null ? void 0 : _b.reduce((e2, t) => e2 + t, 0), this.setActiveSlideClass(i), this.sliderElement.scrollTo({ top: 0, left: e, behavior: "instant" }));
    });
    __publicField(this, "setScrollPosition", (i) => {
      var _a, _b;
      var e = (_a = this.getCurrentSliderStates()) == null ? void 0 : _a.allSlideWidths;
      0 <= i && (e = (_b = e == null ? void 0 : e.map((e2, t) => {
        if (t <= i - 1) return e2;
      }).filter((e2) => e2)) == null ? void 0 : _b.reduce((e2, t) => e2 + t, 0), this.setActiveSlideClass(i), this.sliderElement.scrollTo({
        top: 0,
        left: e,
        behavior: "smooth"
      }));
    });
    __publicField(this, "setScrollPositionNotActive", (i) => {
      var _a, _b;
      var e = (_a = this.getCurrentSliderStates()) == null ? void 0 : _a.allSlideWidths;
      0 <= i && (e = (_b = e == null ? void 0 : e.map((e2, t) => {
        if (t <= i - 1) return e2;
      }).filter((e2) => e2)) == null ? void 0 : _b.reduce((e2, t) => e2 + t, 0), this.sliderElement.scrollTo({ top: 0, left: e, behavior: "smooth" }));
    });
    __publicField(this, "getPositionOfSlideById", (t) => {
      return [...this.sliderElement.querySelectorAll(".slide:not(.js-hidden)")].findIndex((e) => e.dataset.deeplinkTarget == t);
    });
    __publicField(this, "handleClickNewActiveSlide", (e) => {
      var t = e.target.closest(".slide"), e = e.target.closest(".dot");
      let i = 0;
      t && (t = t.getAttribute("id"), i = this.getPositionOfSlideById(t)), e && (i = e.dataset.index), this.setActiveIndicator(i), this.setActiveThumb(i), this.setScrollPosition(i), this.setStylingArrows(i);
    });
    __publicField(this, "setListenersToTheDots", () => {
      var _a;
      var e = this.coralScrollElement.querySelector(".coral-scroll__indicator");
      e && ((_a = [...e.querySelectorAll(".dot")]) == null ? void 0 : _a.map((e2) => {
        e2.addEventListener("click", (e3) => this.handleClickNewActiveSlide(e3));
      }));
    });
    __publicField(this, "setListenersToThumbs", () => {
      if (this.sliderConfig.isThumbsSlider) {
        var e = [
          ...this.sliderElement.querySelectorAll(".slide:not(.js-hidden):not(.js-clone)")
        ];
        const s = this.coralScrollElement.dataset.thumbsParentClass;
        e == null ? void 0 : e.map((e2, t) => {
          let i = t;
          e2.addEventListener("click", () => {
            this.sendEventRequestToScrollToNewSlide(i, s);
          });
        });
      }
    });
    __publicField(this, "updateSlides", () => {
      this.sliderElement.classList.add("js-updating-slides"), this.setNewDots(), this.setStylingArrows(), this.setClonesOfSlideForInifiteScroll(), this.setListenersToThumbs(), setTimeout(() => {
        var e = this.getCurrentSliderStates();
        this.setListenersToTheDots(), this.setActiveIndicator(e == null ? void 0 : e.activeSlide);
      }, 100), this.sliderElement.classList.remove("js-updating-slides");
    });
    __publicField(this, "callback", this.debounce((e) => {
      for (const t of e) "childList" === t.type && this.updateSlides();
    }, 10));
    __publicField(this, "setNewDots", this.debounce(() => {
      const i = this.coralScrollElement.querySelector(".coral-scroll__indicator");
      var e;
      i && (e = [...this.sliderElement.querySelectorAll(".slide:not(.js-hidden):not(.js-clone)")], i.innerHTML = "", e.map((e2, t) => {
        i.insertAdjacentHTML(
          "beforeEnd",
          __privateGet(this, _createDotElement).call(this, t)
        );
      }));
    }, 10));
    __publicField(this, "setClonesOfSlideForInifiteScroll", () => {
      var e;
      true === this.sliderConfig.infinite && "true" !== this.sliderElement.dataset.clonesActive && (e = (e = this.sliderElement.querySelectorAll(".slide:not(.js-hidden):not(.js-clone)")) ? [...e] : null, this.sliderElement.dataset.clonesActive = "true", e.map((e2, t) => {
        0 === (e2.dataset.slideId = t) && ((e2 = e2.cloneNode(true)).classList.add("js-clone"), e2.dataset.cloneId = t, this.sliderElement.insertAdjacentElement("beforeend", e2));
      }));
    });
    __publicField(this, "handlePreviousSlide", () => {
      var _a;
      var e = this.getCurrentSliderStates();
      let t = e == null ? void 0 : e.activeSlide;
      0 === (e == null ? void 0 : e.activeSlide) ? t = 0 : --t, true === this.sliderConfig.infinite && (e = (_a = ((e = this.sliderElement.querySelectorAll(".slide:not(.js-hidden)")) ? [...e] : null)[t]) == null ? void 0 : _a.dataset.cloneId, t = e), this.sliderConfig.isThumbsSlider ? (0 < t ? --this.shadowActiveSlidePosition : 0 === t && (this.shadowActiveSlidePosition = 0), this.setScrollPositionNotActive(this.shadowActiveSlidePosition)) : (this.shadowActiveSlidePosition = t, this.setActiveIndicator(t), this.setActiveThumb(t), this.setScrollPosition(t), this.setStylingArrows(t), this.sendEventScrolledToNewSlide(t));
    });
    __publicField(this, "handleNextSlide", () => {
      var _a, _b;
      var e;
      let t = (_a = this.getCurrentSliderStates()) == null ? void 0 : _a.activeSlide;
      true === this.sliderConfig.infinite && (e = (_b = ((e = this.sliderElement.querySelectorAll(".slide:not(.js-hidden)")) ? [...e] : null)[t]) == null ? void 0 : _b.dataset.cloneId) ? (this.setScrollPositionWithoutScroll(Number(e)), t = Number(e) + 1) : t += 1, this.sliderConfig.isThumbsSlider ? (e = ((e = this.sliderElement.querySelectorAll(".slide:not(.js-hidden)")) ? [...e] : null).length, t <= e && (this.shadowActiveSlidePosition += 1), this.setScrollPositionNotActive(this.shadowActiveSlidePosition)) : (this.shadowActiveSlidePosition = t, this.setActiveIndicator(t), this.setActiveThumb(t), this.setScrollPosition(t), this.setStylingArrows(t), this.sendEventScrolledToNewSlide(t));
    });
    __publicField(this, "handleNextGrabSlide", this.debounce(() => {
      var e, t = this.getCurrentSliderStates();
      this.sliderConfig.isThumbsSlider ? (e = ((e = this.sliderElement.querySelectorAll(".slide:not(.js-hidden)")) ? [...e] : null).length, this.shadowActiveSlidePosition + 1 <= e && (this.shadowActiveSlidePosition += 1), this.setScrollPositionNotActive(this.shadowActiveSlidePosition)) : this.setScrollPosition(t.activeSlide + 1);
    }, 100));
    __publicField(this, "handlePreviousGrabSlide", this.debounce(() => {
      var e = this.getCurrentSliderStates();
      this.sliderConfig.isThumbsSlider ? (0 < this.shadowActiveSlidePosition - 1 ? --this.shadowActiveSlidePosition : this.shadowActiveSlidePosition - 1 == 0 && (this.shadowActiveSlidePosition = 0), this.setScrollPositionNotActive(this.shadowActiveSlidePosition)) : this.setScrollPosition(e.activeSlide - 1);
    }, 100));
    __publicField(this, "setActiveSlide", (e) => {
      this.setActiveIndicator(e), this.setActiveThumb(e), this.setScrollPosition(e), this.setStylingArrows(e), this.sendEventScrolledToNewSlide(e), this.sliderConfig.autoScrollDuration && (e = this.debounce(() => {
        false === this.isTouchDown && (this.handleNextSlide(), this.coralScrollElement.style.setProperty("--animation-state", "running"));
      }, 100), this.handleInterval = setInterval(e, this.sliderConfig.autoScrollDuration), this.coralScrollElement.style.setProperty("--animation-state", "running"));
    });
    __publicField(this, "setActiveSlideWithoutScroll", (e) => {
      this.setActiveIndicator(e), this.setActiveThumb(e), this.setScrollPositionWithoutScroll(Number(e)), this.setStylingArrows(e), this.sendEventScrolledToNewSlide(e);
    });
    __publicField(this, "initializeSlider", () => {
      const e = this.sliderConfig.startPositionId || 0;
      if (this.coralScrollElement.dataset.coralScrollId = this.coralScrollId, this.setNewDots(), this.setActiveSlideClass(e), this.setListenerArrows(), this.setClonesOfSlideForInifiteScroll(), setTimeout(() => {
        this.setListenersToTheDots(), this.setListenersToThumbs(), this.setActiveIndicator(e);
      }, 50), document.addEventListener("request-to-slide", (e2) => {
        var e2 = e2.detail, t = Number(e2.activeSlide), e2 = e2.targetSliderClass, i = this.sliderElement.querySelectorAll(".slide:not(.js-hidden)"), i = (i ? [...i] : null).length;
        0 <= t && t <= i && (this.shadowActiveSlidePosition = t), this.coralScrollElement.classList.contains(e2) && this.setActiveSlide(t);
      }), document.addEventListener(
        "update-coral-scroll",
        (e2) => {
          e2 = e2.detail.coralScrollId;
          Number(e2) === Number(this.coralScrollId) && this.updateSlides();
        }
      ), this.sliderConfig.isThumbsSlider || this.sliderElement.addEventListener("scroll", this.debounce(() => {
        var _a;
        var e2, t = this.getCurrentSliderStates(), i = Number(t == null ? void 0 : t.activeSlide);
        true === this.sliderConfig.infinite && (e2 = (_a = ((e2 = this.sliderElement.querySelectorAll(".slide:not(.js-hidden)")) ? [...e2] : null)[i]) == null ? void 0 : _a.dataset.cloneId) && this.setScrollPositionWithoutScroll(Number(e2)), t !== i && (this.setActiveSlideClass(i), this.setActiveIndicator(i), this.setActiveThumb(i), this.setStylingArrows(i));
      }), 0), this.sliderConfig.autoScrollDuration) {
        const t = this.debounce(() => {
          false === this.isTouchDown && (this.handleNextSlide(), this.coralScrollElement.style.setProperty("--animation-state", "running"));
        }, 100), i = this.debounce(() => {
          this.handleInterval = setInterval(t, this.sliderConfig.autoScrollDuration);
        }, 100);
        i(), this.sliderElement.addEventListener("touchstart", () => {
          this.isTouchDown = true, clearInterval(this.handleInterval), this.coralScrollElement.style.setProperty("--animation-state", "paused");
        }, true, { passive: true }), this.sliderElement.addEventListener("touchend", () => {
          this.isTouchDown = false, i(), this.coralScrollElement.style.setProperty("--animation-state", "running");
        }, true, { passive: true }), document.addEventListener("scrolled-to-slide", (e2) => {
          e2.detail.sendFromSliderElement === this.coralScrollElement && (clearInterval(this.handleInterval), this.coralScrollElement.style.setProperty("--animation-state", "paused"));
        }, true, { passive: true }), this.sliderElement.addEventListener("scrollstart", () => {
          this.isTouchDown = true, clearInterval(this.handleInterval), this.coralScrollElement.style.setProperty("--animation-state", "paused");
        }, true, { passive: true }), this.sliderElement.addEventListener("scrollend", () => {
          this.isTouchDown = false, i(), this.coralScrollElement.style.setProperty("--animation-state", "running");
        }, true, { passive: true }), this.sliderElement.addEventListener("mouseenter", () => {
          this.isTouchDown = true, clearInterval(this.handleInterval), this.coralScrollElement.style.setProperty("--animation-state", "paused");
        }, true, { passive: true }), this.sliderElement.addEventListener("mouseleave", this.debounce(() => {
          this.isTouchDown = false, i(), this.coralScrollElement.style.setProperty("--animation-state", "running");
        }, 100), true, { passive: true });
      }
      if (this.sliderElement.addEventListener("mousedown", () => {
        this.showOverlay = true;
      }), this.sliderElement.addEventListener("mousemove", (e2) => {
        var _a, _b;
        this.showOverlay && ((_a = this.grabOverlayElement) == null ? void 0 : _a.classList.add("js-active"), e2 = new MouseEvent(
          "mousedown",
          e2
        ), (_b = this.grabOverlayElement) == null ? void 0 : _b.dispatchEvent(e2));
      }), this.sliderElement.addEventListener("mouseup", () => {
        var _a, _b;
        var e2 = new MouseEvent("mouseup");
        (_a = this.grabOverlayElement) == null ? void 0 : _a.classList.remove("js-active"), (_b = this.grabOverlayElement) == null ? void 0 : _b.dispatchEvent(e2), this.showOverlay = false;
      }), this.grabOverlayElement) {
        this.grabOverlayElement.addEventListener("mousedown", (e2) => {
          var t = [...this.sliderElement.querySelectorAll(".slide:not(.js-hidden)")];
          this.isDown = true, this.sliderElement.classList.add("js-active"), this.startX = e2.pageX - this.sliderElement.offsetLeft, t.map((e3) => {
            e3.ondragstart = function() {
              return false;
            };
          });
        });
        const s = () => {
          this.isDown = false, this.grabOverlayElement.classList.remove("js-active"), this.showOverlay = false, setTimeout(() => {
            this.sliderElement.classList.remove("js-active");
          }, 1e3);
        };
        this.grabOverlayElement.addEventListener("mouseup", (e2) => s()), this.grabOverlayElement.addEventListener("mousemove", (e2) => {
          this.isDown && (e2.preventDefault(), (e2 = e2.pageX - this.sliderElement.offsetLeft - this.startX) >= -this.sliderConfig.grabVelocity && e2 <= 0 && this.handleNextGrabSlide(), e2 >= this.sliderConfig.grabVelocity) && 0 <= e2 && this.handlePreviousGrabSlide();
        });
      }
    });
    this.coralScrollElement = e, this.sliderElement = e.querySelector(".coral-scroll__slider"), this.grabOverlayElement = e.querySelector(".coral-scroll__grab-overlay"), this.sliderConfig = this.createSliderConfig(), this.slideScrollLeft = this.sliderElement.scrollLeft, this.showOverlay = false, this.isDown = false, this.startX, this.isTouchDown = false, this.coralScrollId = Date.now(), this.shadowActiveSlidePosition = 0, this.handleInterval, this.initializeSlider(), this.oberserverConfig = {
      attributes: false,
      childList: true,
      subtree: false
    }, new MutationObserver(this.callback).observe(this.coralScrollElement, this.oberserverConfig);
  }
}
_createDotElement = new WeakMap();
class CoralScrollElement extends HTMLElement {
  constructor() {
    super();
    const coralScrollElement = this;
    const coralScroll = new CoralScrollCore(coralScrollElement);
    if (coralScrollElement.dataset.autoScroll) {
      setInterval(() => {
        coralScroll.handleNextSlide();
      }, parseInt(coralScrollElement.dataset.autoScroll, 10));
    }
  }
}
if (customElements.get("coral-scroll") === void 0) {
  customElements.define("coral-scroll", CoralScrollElement);
}
